import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AlertType } from '../../../shared/models/alertType';
import { AccountService } from '../../../core/services/account.service';
import { showAlertDialog } from '../../../shared/helpers/showAlertDialog';
import { BRANDING } from '../../../core/constants/branding.constants';

@Component({
    selector: 'app-recuperar-senha',
    imports: [MatIconModule, ReactiveFormsModule, CommonModule],
    templateUrl: './recuperar-senha.component.html',
    styleUrl: './recuperar-senha.component.scss'
})
export class RecuperarSenhaComponent {
  branding = BRANDING;
  recuperarSenhaForm: FormGroup;
  emailFocused: boolean = false;

  constructor(
    private fb: FormBuilder, 
    private router: Router, 
    private dialog: MatDialog,
    private accountService: AccountService,
  ) {
    this.recuperarSenhaForm = this.fb.group({
      email: ['', {
        validators: [Validators.required, Validators.email],
      }],
    });
  }

  onSubmit() {
    if (this.recuperarSenhaForm.valid) {
      this.accountService.forgotPassword(this.recuperarSenhaForm.value.email).subscribe({
        next: () => {
          const dialogRef = showAlertDialog(this.dialog, AlertType.Success, 'Sucesso!', 'Se o e-mail informado for válido, enviaremos um link para redefinir sua senha.');
          dialogRef.afterClosed().subscribe(() => {
            this.navigateToLogin();
          });
        }
      });
    }
  }

  navigateToLogin() {
    this.router.navigate(['account/login']);
  }
}
